<template>
  <vg-view-field
      v-bind="$attrs"
      v-on="$listeners"
      :class="{vertical: maximum}"
      :label="label"
  >
    <vg-image-uploader
        :class="{maximum}"
        disabled
        :file-list="imageFiles"
        :preview-full-image="false"
        @click-preview="onPreview"
    />
  </vg-view-field>
</template>

<script>
import VgImageUploader from '@/components/Commons/VgImageUploader';
import VgViewField from '@/components/Commons/VgViewField';
import {client} from "@/libraries/http";
import {ImagePreview} from "vant";

export default {
  name: "ImageField",
  components: {VgViewField, VgImageUploader},
  props: {
    label: String,
    value: String,
    maximum: Boolean
  },
  computed: {
    imageFiles() {
      return this.value ? [{url: this.value}] : []
    }
  },
  methods: {
    onPreview(file, detail) {
      let params = {
        urls: this.imageFiles.map(file => file.url)
      }
      client.post('/api/h5/file_app/getSignedUrls', params)
          .then(rsp => {
            ImagePreview({
              images: rsp.data,
              startPosition: detail.index,
            });
          })
    },
  }
}
</script>

<style scoped>

</style>